/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

/* -------------------------- required imports for API Call -------------------------- */
// import Gateway for API fetch call
import { getData } from "utils/Gateway";

// import all URLs from url_helper
import * as url from "helpers/url_helper";
/* ----------------------------------------------------------------------------------- */

const Faq = () => {
  // saving user token here
  const token = localStorage.getItem("token");

  // 👇️ get ID from url
  const params = useParams();

  // Initial useState to save all the incoming data from API.
  const [jobDetailsData, setJobDetailsData] = useState(null);

  // Function to call the API and get all the data
  const getJobDetailsData = async (id) => {
    let requestURL =
      url.API_BaseUrl +
      url.API_CHALLENGES_DETAILS_FAQ_TAB +
      `?token=${token}` +
      `&cid=${id}`;

    try {
      // console.log(
      //   "requesting URL to get all the job details faq tab ------> ",
      //   requestURL
      // );

      const response = await getData(requestURL);
      console.log(
        "Received Response in challenges details faq tab --------> ",
        response
      );

      if (response.status) {
        setJobDetailsData(response.data);
      } else {
        console.log("Some error occurred ------> ", response);
      }
    } catch (error) {
      console.log("Error of indra activity post is----->", error);
    }
  };

  // useEffect from here
  useEffect(() => {
    getJobDetailsData(params.id);
  }, []);

  return (
    <>
      {jobDetailsData == null ? (
        // ----------------------- Placeholder starts here -----------------------
        <div className="course_detailspnl">
          <div className="contnt_hdng">
            <span
              className="placeholder rounded-3 col-1"
              style={{ height: "22px" }}
            ></span>
          </div>
          <div className="accordian_area">
            <div className="accordion accordion-flush" id="faq-accordian">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                  >
                    <span className="placeholder placeholder-sm rounded-3 col-5"></span>
                    <span
                      className="placeholder rounded-3"
                      style={{ width: "24px", height: "24px" }}
                    ></span>
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faq-accordian"
                >
                  <div className="accordion-body">
                    <div className="faq_para">
                      <span className="placeholder placeholder-sm rounded-3 col-12"></span>
                      <span className="placeholder placeholder-sm rounded-3 col-10"></span>
                      <span className="placeholder placeholder-sm rounded-3 col-4"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                  >
                    <span className="placeholder placeholder-sm rounded-3 col-5"></span>
                    <span
                      className="placeholder rounded-3"
                      style={{ width: "24px", height: "24px" }}
                    ></span>
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faq-accordian"
                >
                  <div className="accordion-body">
                    <div className="faq_para">
                      <span className="placeholder placeholder-sm rounded-3 col-12"></span>
                      <span className="placeholder placeholder-sm rounded-3 col-10"></span>
                      <span className="placeholder placeholder-sm rounded-3 col-4"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                  >
                    <span className="placeholder placeholder-sm rounded-3 col-5"></span>
                    <span
                      className="placeholder rounded-3"
                      style={{ width: "24px", height: "24px" }}
                    ></span>
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faq-accordian"
                >
                  <div className="accordion-body">
                    <div className="faq_para">
                      <span className="placeholder placeholder-sm rounded-3 col-12"></span>
                      <span className="placeholder placeholder-sm rounded-3 col-10"></span>
                      <span className="placeholder placeholder-sm rounded-3 col-4"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // ----------------------- Mapped data starts here -----------------------
        <div className="course_detailspnl">
          <div className="contnt_hdng">
            <h4>Faqs</h4>
          </div>
          <div className="accordian_area">
            {jobDetailsData.faq != null && jobDetailsData.faq.length > 0 ? (
              <div className="accordion accordion-flush" id="faq-accordian">
                {jobDetailsData.faq.map((item, index) => {
                  return (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={"#flush-collapseOne" + index}
                        >
                          <span>{item.question}</span>
                          <i className="material-icons-round">expand_more </i>
                        </button>
                      </h2>
                      <div
                        id={"flush-collapseOne" + index}
                        className="accordion-collapse collapse"
                        data-bs-parent="#faq-accordian"
                      >
                        <div className="accordion-body">
                          <div className="faq_para">
                            <p>{item.answer}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              // ----------------------- Placeholder starts here -----------------------
              <div className="course_detailspnl">
                <div className="contnt_hdng">
                  <span
                    className="placeholder rounded-3 col-1"
                    style={{ height: "22px" }}
                  ></span>
                </div>
                <div className="accordian_area">
                  <div className="accordion accordion-flush" id="faq-accordian">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseOne"
                        >
                          <span className="placeholder placeholder-sm rounded-3 col-5"></span>
                          <span
                            className="placeholder rounded-3"
                            style={{ width: "24px", height: "24px" }}
                          ></span>
                        </button>
                      </h2>
                      <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse"
                        data-bs-parent="#faq-accordian"
                      >
                        <div className="accordion-body">
                          <div className="faq_para">
                            <span className="placeholder placeholder-sm rounded-3 col-12"></span>
                            <span className="placeholder placeholder-sm rounded-3 col-10"></span>
                            <span className="placeholder placeholder-sm rounded-3 col-4"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseTwo"
                        >
                          <span className="placeholder placeholder-sm rounded-3 col-5"></span>
                          <span
                            className="placeholder rounded-3"
                            style={{ width: "24px", height: "24px" }}
                          ></span>
                        </button>
                      </h2>
                      <div
                        id="flush-collapseTwo"
                        className="accordion-collapse collapse"
                        data-bs-parent="#faq-accordian"
                      >
                        <div className="accordion-body">
                          <div className="faq_para">
                            <span className="placeholder placeholder-sm rounded-3 col-12"></span>
                            <span className="placeholder placeholder-sm rounded-3 col-10"></span>
                            <span className="placeholder placeholder-sm rounded-3 col-4"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseThree"
                        >
                          <span className="placeholder placeholder-sm rounded-3 col-5"></span>
                          <span
                            className="placeholder rounded-3"
                            style={{ width: "24px", height: "24px" }}
                          ></span>
                        </button>
                      </h2>
                      <div
                        id="flush-collapseThree"
                        className="accordion-collapse collapse"
                        data-bs-parent="#faq-accordian"
                      >
                        <div className="accordion-body">
                          <div className="faq_para">
                            <span className="placeholder placeholder-sm rounded-3 col-12"></span>
                            <span className="placeholder placeholder-sm rounded-3 col-10"></span>
                            <span className="placeholder placeholder-sm rounded-3 col-4"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Faq;
